import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=62bb2bfe&scoped=true&"
import script from "./OrderTable.vue?vue&type=script&lang=js&"
export * from "./OrderTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=62bb2bfe&prod&lang=css&"
import style1 from "./OrderTable.vue?vue&type=style&index=1&id=62bb2bfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb2bfe",
  null
  
)

export default component.exports